export const SUPPORTED_LANGUAGES = ['en', 'es'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en'

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}

export function normalizeSupportedLanguage(value: unknown): SupportedLanguage {
  if (typeof value !== 'string') return DEFAULT_LANGUAGE
  const trimmed = value.trim()
  return isSupportedLanguage(trimmed) ? trimmed : DEFAULT_LANGUAGE
}

export const USER_LANGUAGE_OPTIONS: Array<{ value: SupportedLanguage; label: string }> = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
]
